import http from '@/utils/http'
import convert from '@/utils/model-convert'
import {FormArgument, PhoneArgument} from '@/models/strategy-survey'
import {QueArgument} from '@/models/tourist/questionnaire'

const SURVEY = '/rest/tourist/report/survey' // 游客的问卷调查
const REPORT = '/rest/tourist/report/{id}/report' // 大数据定制生成的方案
const MEES_URL = '/rest/tourist/tourist-feedback'
const MEES_LOGIN_URL = '/rest/customer/feedback/customer-messa'
const IND_URL = '/rest/tourist/item-industries'
const QUE_URL = '/rest/tourist/surveys' // 填写问卷调查
const QUE_URL_LOG = '/rest/customer/platform/survey' // 登录之后填写问卷调查

export default {
  survey ({form}, cb) {
    let postData = convert.toStringify(form, FormArgument)
    http.post(SURVEY, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  report (id, cb) {
    http.get(REPORT.replace('{id}', id)).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  industries (cb) {
    http.get(IND_URL).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  create ({form}, cb) {
    let postData = convert.toStringify(form, PhoneArgument)
    http.post(MEES_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  createLogin ({form}, cb) {
    let postData = convert.toStringify(form, PhoneArgument)
    http.post(MEES_LOGIN_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  quest ({form}, cb) {
    let postData = convert.toStringify(form, QueArgument)
    http.post(QUE_URL, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  },
  questLogin ({form}, cb) {
    let postData = convert.toStringify(form, QueArgument)
    http.post(QUE_URL_LOG, postData, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).then(response => cb(response)).catch(trace => cb(trace.response))
  }
}



// WEBPACK FOOTER //
// ./src/api/tourist/strategy-survey.js